// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".updates{height:365px;padding-top:20px}.updates .h2{font-size:2rem;font-weight:800;margin-bottom:10px;padding:0 10px}.updates .slider-wrapper{margin-top:20px}.updates .btns button.active{background-color:rgba(207,161,0,.9)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
